import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useCoachRail } from "@/context/CoachRailContext";
import { shortcutLabel } from "@/lib/keyboard";

/**
 * The sidebar Ask row (redesign 1c) — the AI's front door. Opens the ⌘K command
 * palette (2b), which both searches and asks; the global ⌘K shortcut (owned by
 * the palette) does the same from anywhere. This keeps the AI to one obvious,
 * discoverable entry point.
 */
export function SidebarAskRow() {
  const { t } = useTranslation("nav");
  const { openPalette } = useCoachRail();

  return (
    <button
      type="button"
      onClick={openPalette}
      className="flex h-9 w-full items-center gap-2 rounded-[9px] border border-border bg-card px-2.5 text-left transition-colors hover:bg-accent focus-visible:border-primary focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/15"
    >
      <Sparkles className="size-[15px] shrink-0 text-primary" />
      <span className="flex-1 truncate text-[13px] text-muted-foreground">
        {t("ask.placeholder")}
      </span>
      <kbd className="pointer-events-none hidden shrink-0 select-none items-center gap-0.5 rounded border border-border bg-muted px-1.5 font-mono text-[10.5px] font-medium text-muted-foreground sm:inline-flex">
        {shortcutLabel("K")}
      </kbd>
    </button>
  );
}
